import React from 'react';
import { connect } from 'react-redux';

import { BANNER_TYPE_COOKIE } from '../../services/banner/constants';
import CookieBannerComponent from '../header/cookiebanner/CookieBannerComponent';
import { BannerRootContainer } from './BannerRootStyle';

// Chaque nouvelle Banner spécifique doit être ajoutée ici
const BANNER_COMPONENTS = {
    [BANNER_TYPE_COOKIE]: CookieBannerComponent
};

const BannerRoot = ({ banner, dispatch }) => {
    if (!banner.bannerType) {
        return null;
    }

    const SpecificBanner = BANNER_COMPONENTS[banner.bannerType];

    return (
        <BannerRootContainer>
            <SpecificBanner {...banner.bannerProps} />
        </BannerRootContainer>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        banner: state.banner
    };
};

export default connect(mapStateToProps)(BannerRoot);



// WEBPACK FOOTER //
// ./src/components/banner/BannerRoot.js